import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-cards-grid',
    templateUrl: './cards-grid.component.html',
    styleUrls: ['./cards-grid.component.scss']
})
export class CardsGridComponent {
    @Input() desktopColumns = 4;

    @Input() minCardWidth = 220;
}
